<div class="register-container">
  <div class="registration-container">
    <div class="registration-card">
      <!-- Header -->
      <div class="card-header">
        <div>
          <mat-icon class="header-icon" matPrefix>account_circle</mat-icon>
        </div>
        <div class="header-title">
          <h1>Kundenregistrierung</h1>
        </div>
      </div>
      <div *ngIf="success" class="success-container">
        <div class="success-message" id="successMessage">
          <div>
            <mat-icon class="success-icon">check</mat-icon>
          </div>
          <h2>Erfolgreich registriert!</h2>
          <p>Vielen Dank für Ihre Registrierung. Sie erhalten in Kürze eine Bestätigungs-E-Mail.</p>
        </div>
      </div>

      <div *ngIf="error && !loading" class="error-container">
        <mat-icon color="warn">error</mat-icon>
        <p>{{ error }}</p>
      </div>
      <!-- Content -->
      <form id="registrationForm" *ngIf="!success && !error && nonce && signature" (ngSubmit)="onSubmit()"
        class="register-form">
        <div class="card-content">
          <p class="welcome-text">
            Willkommen! Bitte füllen Sie die folgenden Felder aus, um Ihre Registrierung abzuschließen.
          </p>

          <div class="form-group">
            <div class="input-wrapper">
              <input type="text" class="form-input" placeholder="Vorname*" [(ngModel)]="firstName" name="firstName"
                id="vorname">
              <mat-icon class="input-icon">badge</mat-icon>
            </div>
          </div>
          <div class="form-group">
            <div class="input-wrapper">
              <input type="text" class="form-input" placeholder="Nachname*" [(ngModel)]="lastName" name="lastName"
                required id="nachname">
              <mat-icon class="input-icon">badge</mat-icon>
            </div>
          </div>
          <button mat-raised-button type="submit" [disabled]="loading" class="submit-btn">
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <span *ngIf="!loading">Registrierung abschließen</span>
          </button>
          <div class="card-footer">
            <p class="footer-text">
              Bereits registriert?
              <a href="#" class="footer-link">Jetzt anmelden</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>